import { styled } from '@mui/material';

export const ImagesViewerWrapper = styled('div')(({ theme }) => ({
  gridArea: 'gallery',
  '@media print': {
    pageBreakInside: 'avoid',
    breakInside: 'avoid',
  },
}));
